import { createElement, lazy, Suspense, type ComponentType, type ReactElement } from "react";
import { defineWebModule, Loading, useShell } from "@tc/ui";
import { manifest } from "./manifest.js";
import { withShop } from "./web/shopfixes.js";

const NoAccess = lazy(() => import("./web/shared.js").then((m) => ({ default: m.NoAccess })));

/**
 * Every page needs Product updates' view permission: a site manager opening a shared or typed link (e.g.
 * /product-updates/sent) gets the friendly no-access card, not a page that half-draws and fails its calls.
 */
const page = <K extends string>(file: () => Promise<Record<K, () => ReactElement>>, name: K) => {
  const Page = lazy(() => file().then((m) => ({ default: m[name] as () => ReactElement })));
  const Gated: ComponentType = () => {
    const { can } = useShell();
    return createElement(Suspense, { fallback: createElement(Loading) }, createElement(can("product-updates.view") ? Page : NoAccess));
  };
  return withShop(Gated);
};

export default defineWebModule({
  manifest,
  pages: {
    "": page(() => import("./web/HubPage.js"), "HubPage"),
    "/costs": page(() => import("./web/CostsPage.js"), "CostsPage"),
    "/suppliers": page(() => import("./web/SuppliersPage.js"), "SuppliersPage"),
    "/departments": page(() => import("./web/DepartmentsPage.js"), "DepartmentsPage"),
    "/mapping": page(() => import("./web/MappingPage.js"), "MappingPage"),
    "/vat": page(() => import("./web/VatPage.js"), "VatPage"),
    "/nonscan": page(() => import("./web/NonScanPage.js"), "NonScanPage"),
    "/coverage": page(() => import("./web/CoveragePage.js"), "CoveragePage"),
    "/sent": page(() => import("./web/SentPage.js"), "SentPage"),
    "/settings": page(() => import("./web/SettingsPage.js"), "SettingsPage"),
  },
});
